import { clientEnv } from '@/config/env/client';

export const DAVINCI_CDN = clientEnv.NEXT_PUBLIC_DAVINCI_ASSETS_CDN || 'https://cdn.davinci.care';
export const CHANNEL_VIDEO = 'ONLINE';
export const CHANNEL_STUDIO = 'ONLINE';

export const BASE_URL = clientEnv.NEXT_PUBLIC_SITE_URL ?? '';
